import { computed } from 'vue';
import { canUseMessageHub as canUseMessageHubUtil } from '~/components/message-hub/messageHubUtil';
import { SENDER_TYPE_CORPORATE, SENDER_TYPE_GROUP } from '~/constants/senderTypes';
import { GROUP_STATUSES_SENDING } from '~/constants/groupStatuses';

// TODO: Rename to something else, no longer only related to group
export const useCurrentGroup = () => {
    const getCurrentGroupId = () => {
        return Spark.state.currentGroup?.group_id;
    };

    // TODO: move to computed, remember to move all usage on <script> tags to include `.value`
    const roleOnCurrentGroup = Spark?.roleOnCurrentGroup;
    const roleOnCurrentOrgUnit = Spark?.roleOnCurrentOrgUnit;

    const currentGroup = computed(() => Spark.state.currentGroup);
    const currentOrgUnit = computed(() => Spark.state.currentOrgUnit);

    const onCorporate = () => {
        return !currentGroup.value?.group_id && !currentOrgUnit.value?.id;
    };

    const canAccessCorporate = computed(() => Spark.roleOnCurrentTeam !== 'none');

    const currentGroupCanSend = computed(
        () => !currentGroup.value?.group_id || GROUP_STATUSES_SENDING.includes(currentGroup.value.status)
    );

    const canUseMessageHub = computed(() => canUseMessageHubUtil());

    const senderType = computed(() => {
        // TODO: Handle organizational unit context when OU functionality is implemented
        if (onCorporate()) {
            return SENDER_TYPE_CORPORATE;
        } else {
            return SENDER_TYPE_GROUP;
        }
    });

    const getContext = () => {
        return {
            teamId: Spark.state.currentTeam.id,
            orgUnitId: currentOrgUnit.value?.id,
            groupId: getCurrentGroupId(),
        };
    };

    return {
        canAccessCorporate,
        canUseMessageHub,
        currentOrgUnit,
        currentGroup,
        currentGroupCanSend,
        getContext,
        getCurrentGroupId,
        onCorporate,
        roleOnCurrentGroup,
        roleOnCurrentOrgUnit,
        senderType,
    };
};
